export class GetDataModel {
  getTransaction = () => {
    return {
      withdrawelreason: '',
      receipt: [],
      payments: {
        couponout: 0,
        creditreceipt: 0,
        pin: 0,
        couponin: 0,
        withdrawel: 0,
        storecredit: 0,
        creditcard: 0,
        consignment: 0,
        cash: 0,
        webshop: 0,
      },
      totalStoreCreditPaid: 0,
      nr: '',
      shopname: '',
      shift: '',
      totalDiscountCoupon: 0,
      totalNumber: 0,
      totalReturn: 0,
      totalCoupon: 0,
      reqid: 0,
      change: 0,
      receipt_email: '',
      receiptNr: 0,
      difference: 0,
      shop: {},
      totalDiscount: 0,
      amountEntry: 0,
      customer: null,
      device: '',
      totalPaid: 0,
      version: { date: '20140710104913', v: 8 },
      printed: '',
      selectedLine: 0,
      remark: '',
      vat: {
        highamount: 0,
        lowtotal: 0,
        hightotal: 0,
        zeroamount: 0,
        zerototal: 0,
        lowamount: 0,
      },
      totalAmount: 0,
      pinError: '',
      pinInfo: '',
      type: 0,
      discountreason: '',
      cashier: {},
      loyaltyPoints: 0,
      active: true,
    };
  };
}

/*
 * @describe
 * Service to get data models from the softwear_metadata collection. Requires
 * a callback for setting the data model due to the service being asyncronous
 * @deprecated
 * At some point, move to v7 collection services
 */
angular.module('posApp').service('getDataModel', () => {
  return new GetDataModel();
});
